export default __webpack_public_path__ + "static/facts_2-74005d76074ea430ed08d53fd93b9327.webp";